import { defineComponent, ref, watch, onMounted } from 'vue';
import HetaoLogo from '@/assets/image/home/logo3.png';
import HetaoLogoWithoutBrand from '@/assets/image/home/logo5.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import LoginDialog from './LoginDialog.vue';
import GoToEnvCheckDialog from './GoToEnvCheckDialog.vue';
import { SHOW_BRAND, domains } from '@/utils';
import { environment } from '@/utils/environment';
export default defineComponent({
  name: 'SpecialHActiveHeader',
  components: {
    LoginDialog: LoginDialog,
    GoToEnvCheckDialog: GoToEnvCheckDialog,
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function () {
    var selectedKeys = ref([]);
    var showCloseBtn = ref(true);
    var route = useRoute();
    setKeys(route);
    var router = useRouter();
    router.afterEach(function (to) {
      setKeys(to);
    });
    var isHideInfo = Boolean(route.query.from);
    var clickMenuItem = function (e) {
      var key2 = e.key;
      selectedKeys.value = [key2];
      router.push(key2);
    };
    function setKeys(to) {
      var path = to.path;
      // openKeys.value.push(path.slice(0, path.indexOf('/', 1)));
      selectedKeys.value = [path];
    }
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var logout = function () {
      userService.logout();
    };
    var goToUserCenter = function () {
      router.push({
        name: 'UserItemList'
      });
    };
    watch(function () {
      return userService.user;
    }, function (user) {
      enterValidate();
      if (!(user && user.userId)) {
        if (route.meta && route.meta.auth) {
          router.replace({
            name: 'Home'
          });
        }
      }
    });
    var enterValidate = function () {
      if (!route.query.showLoginModal) return;
      if (!(userService.user && userService.user.userId)) {
        loginService.showLoginDialog();
        showCloseBtn.value = false;
      } else {
        loginService.hideLoginDialog();
      }
    };
    onMounted(function () {
      enterValidate();
    });
    var HetaoLogoFinal = SHOW_BRAND ? HetaoLogo : HetaoLogoWithoutBrand;
    var hideEntryFlag = ref(false);
    var currentItemId = '';
    var specialActiveList = environment === 'production' ? [1093] : [233];
    watch(function () {
      return route.name;
    }, function (visible) {
      if (visible === 'ItemDetail') {
        currentItemId = route.params.id;
      } else if (visible === 'ActivityDetail') {
        currentItemId = route.params.itemId;
      } else {
        currentItemId = '';
      }
      hideEntryFlag.value = specialActiveList.includes(Number(currentItemId));
    }, {
      immediate: true
    });
    return {
      HetaoLogoFinal: HetaoLogoFinal,
      selectedKeys: selectedKeys,
      clickMenuItem: clickMenuItem,
      loginService: loginService,
      userService: userService,
      logout: logout,
      goToUserCenter: goToUserCenter,
      SHOW_BRAND: SHOW_BRAND,
      domains: domains,
      showCloseBtn: showCloseBtn,
      hideEntryFlag: hideEntryFlag,
      isHideInfo: isHideInfo
    };
  }
});